import React from 'react';
import { Route } from 'react-router-dom';
import Routes from './routes';
import CreerCompteEtape1 from './etape-1';
import CreerCompteEtape2 from './etape-2';
import GuideCreerCompte from './aide';
import { getPath } from '../../../utils/router';

const CreerCompte = () => {
    return (
        <>
            <Route
                path={getPath(Routes.subroutes.etape1)}
                render={(subProps) => <CreerCompteEtape1 {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.etape2)}
                render={(subProps) => <CreerCompteEtape2 {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.aide)}
                render={(subProps) => <GuideCreerCompte {...subProps} />}
            />
        </>
    );
};

export default CreerCompte;
